import { openBlob } from '@apis/common';
import { dashboardPdfApis } from '@apis/next/pdfApis';
import { paymentSlipStrings } from '@data/paymentSlip';
import { PaymentSlip } from '@models/next/PaymentSlip';
import { useMutation } from '@tanstack/react-query';
import { zipWith } from 'remeda';

export const useDownloadPaymentSlipPdfs = (d2dNo: string, paymentSlips: PaymentSlip[]) => {
  return useMutation(async () => {
    const downloads = await Promise.all(
      paymentSlips.map(({ id }) =>
        dashboardPdfApis.client.get('/dashboard/pdf/PaymentSlip/:id', {
          params: { id },
        }),
      ),
    );

    if (downloads.length === 1) {
      openBlob(
        downloads[0],
        `${paymentSlipStrings.payment_slip}${paymentSlips[0].payment_slip_no}.pdf`,
      );
    } else {
      const { default: JSZip } = await import('jszip');

      const zip = new JSZip();
      for (const [blob, paymentSlip] of zipWith(
        downloads,
        paymentSlips,
        (x, y) => [x, y] as const,
      )) {
        zip.file(`${paymentSlipStrings.payment_slip}${paymentSlip.payment_slip_no}.pdf`, blob, {
          binary: true,
        });
      }

      const zipBlob = await zip.generateAsync({ type: 'blob' });
      openBlob(zipBlob, `${paymentSlipStrings.payment_slip}${d2dNo}.zip`, 'application/zip');
    }
  });
};
